import React, {useEffect} from 'react';
import {Outlet, useSearchParams} from 'react-router-dom';
import Layout from '@contentlab/components/layout';
import useInvalidateCurrentSubscription from '@contentlab/hooks/use-invalidate-current-subscription';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';
import useNavigation from '@/hooks/use-navigation';
import usePurchaseProcessCompletion from '../../hooks/use-purchase-process-completion/usePurchaseProcessCompletion';

function ContentLab() {
  const {dashboardUser} = useDashboardUserQuery({});
  const navigation = useNavigation();

  useInvalidateCurrentSubscription();

  usePurchaseProcessCompletion();

  useEffect(() => {
    if (!dashboardUser.loaded) {
      return;
    }

    if (!dashboardUser.hasContentLabMemberRole) {
      navigation.navigate('/');
    }
  }, [dashboardUser]);

  if (!dashboardUser.loaded) {
    return null; // or a loading spinner
  }

  return (
    <Layout user={dashboardUser}>
      <Outlet />
    </Layout>
  );
}

export default ContentLab;
